import { supabase } from './supabaseClient';
import { getNegocioId } from './negocioActual';

// Sistema de eventos de uso (analytics), SEPARADO del perfil del usuario.
// Registra "qué hace" cada negocio para medir funcionalidades más usadas,
// retención y comportamiento. Es best-effort: NUNCA rompe la app si falla
// (por eso no se hace throw ni se usa await bloqueante en las pantallas).
//
// Uso desde cualquier parte:
//   import { registrarEvento } from './services/analyticsService';
//   registrarEvento('servicio_creado', { categoria: 'viajes' });
//
// `evento`      → nombre corto y estable en snake_case.
// `propiedades` → objeto libre con contexto (se guarda como jsonb).
export async function registrarEvento(evento, propiedades = {}) {
  try {
    const negocioId = getNegocioId();
    if (!negocioId || !evento) return;
    const { data: sesion } = await supabase.auth.getSession();
    await supabase.from('eventos_uso').insert([{
      negocio_id: negocioId,
      user_id: sesion?.session?.user?.id || null,
      evento,
      propiedades: propiedades || {},
    }]);
  } catch {
    // Silencioso a propósito: medir nunca debe estorbar al usuario.
  }
}
